import React, { useCallback } from "react";
import ButtonLink from "../../components/ButtonLink";
import { Box, Typography, CssBaseline, useMediaQuery } from "@mui/material";
import ThemeWrapper from "../../components/Wrappers/ThemeWrapper";
import LogoMint from "../../components/logo/LogoMint";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles({
  logo: {
    fill: "currentColor",
    color: "white",
    display: "block",
    margin: "0 0 20px 0"
  }
});

const RedirectPage = () => {
  const isMobile = useMediaQuery("(max-width:668px)");
  const loader = document.querySelector(".preloader");
  const classes = useStyles();

  const showPreLoader = useCallback(() => loader?.classList.remove("preloader"), [loader]);
  const addClass = useCallback(() => loader?.classList.add("loader-hide"), [loader]);

  React.useEffect(() => {
    showPreLoader();
    addClass();
  }, [showPreLoader, addClass]);

  return (
    <ThemeWrapper darkMode={true}>
      <CssBaseline />
      <Box display="flex" height="100%" width="100%" justifyContent="center">
        <Box
          display="flex"
          justifyContent="center"
          flexDirection="column"
          alignItems="start"
          height="100%"
          sx={{
            margin: "0 20px"
          }}
          maxWidth="352px"
          width="100%"
        >
          <LogoMint width="80" className={classes.logo} />
          <Box mb={2}>
            <Typography variant="h1">Minting is now in-app!</Typography>
          </Box>

          <Box mb={6}>
            <Typography variant="body2" sx={{ marginBottom: 3 }}>
              All the Atomic minting functionality is now available at v2.akord.com within the Akord app.
            </Typography>
            <Typography variant="body2">
              Log in and select the ‘Atomic NFTs’ tab in a permanent and public vault to start minting.
            </Typography>
          </Box>

          <Box display="flex" justifyContent="start" width="100%">
            <ButtonLink onClick={() => window.open("https://v2.akord.com")} width={isMobile ? "xs" : "md"}>
              Log in at v2.akord.com
            </ButtonLink>
          </Box>
        </Box>
      </Box>
    </ThemeWrapper>
  );
};

export default RedirectPage;
